import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  OnInit,
  input,
  output,
  signal,
} from '@angular/core';
import { OtpChallengeResult } from '@app/models/otp.model';
import { VerifyYourIdentityStep1Component } from './verify-your-identity-step-1/verify-your-identity-step-1.component';
import { VerifyYourIdentityStep2Component } from './verify-your-identity-step-2/verify-your-identity-step-2.component';
import { VerifyYourIdentityLimitReachedComponent } from './verify-your-identity-limit-reached/verify-your-identity-limit-reached.component';

export type IdentityVerificationStep = 'step-1' | 'step-2' | 'limit-reached';

@Component({
  selector: 'app-identity-verification',
  templateUrl: './identity-verification.component.html',
  styleUrl: './identity-verification.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    VerifyYourIdentityStep1Component,
    VerifyYourIdentityStep2Component,
    VerifyYourIdentityLimitReachedComponent,
  ],
})
export class IdentityVerificationComponent implements OnInit {
  readonly email = input('');
  readonly guestId = input('');
  readonly initialStep = input<IdentityVerificationStep>('step-1');

  readonly completed = output<void>();
  readonly canceled = output<void>();
  readonly limitReached = output<void>();

  readonly currentStep = signal<IdentityVerificationStep>('step-1');
  readonly otpChallenge = signal<OtpChallengeResult | null>(null);

  ngOnInit(): void {
    this.setCurrentStep(this.initialStep());
  }

  showStep1(): void {
    this.currentStep.set('step-1');
  }

  showStep2(challenge: OtpChallengeResult): void {
    this.otpChallenge.set(challenge);
    this.currentStep.set('step-2');
  }

  showComplete(): void {
    this.completed.emit();
  }

  cancel(): void {
    this.canceled.emit();
  }

  replaceChallenge(challenge: OtpChallengeResult): void {
    this.otpChallenge.set(challenge);
  }

  /**
   * Handles step-2's `verifyFailed` output. Step-2 owns retry UI, so the
   * parent stays on step-2. Kept as a real handler (not a template no-op)
   * so future analytics/retry logic can hook in here.
   */
  onVerifyFailed(_error: unknown): void {
    // no-op; step-2 handles in-step recovery.
    if (_error && (_error as any).isEmailVerify) {
      this.showStep1();
    }
  }

  showLimitReached(): void {
    this.currentStep.set('limit-reached');
    this.limitReached.emit();
  }

  private setCurrentStep(step: IdentityVerificationStep): void {
    this.currentStep.set(step);
  }
}
